export default class ClientController {
  constructor(resource) {
    this._resource = resource;
  }

  getAllClients() {
    return this._resource('clients')
      .get()
      .then(res => res.json());
  }

  getAllClientsTypeCondominio() {
    return this._resource('clients/by-type-codominio')
      .get()
      .then(res => res.json());
  }

  getClientsByVehicleCategory(vehicleCategoryId) {
    return this._resource(`clients/by-vehicle-category/${vehicleCategoryId}`)
      .get()
      .then(res => res.json());
  }

  getAllClientsWithVehicleModel(selectedCategory) {
    return this._resource('clients/with-vehicle-models')
      .get({ id: selectedCategory })
      .then(res => res.json());
  }

  async getClientById(clientId) {
    return await this._resource(`client/${clientId}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getAllClientsPublic() {
    return this._resource('public/client')
      .get()
      .then(res => res.json());
  }

  async getClientsByUser() {
    let result;
    try {
      let response = await this._resource('clients/user/').get();
      result = response.json();
    } catch (error) {
      result = {
        ok: false,
        message: error,
      };
    }
    return result;
  }

  async getClientsByZipcode(zipcode) {
    let result;
    try {
      let code = parseInt(zipcode.replace(/\.|\-/gi, ''));
      let response = await this._resource(`clients/zipcode/${code}`).get();
      result = response.json();
    } catch (error) {
      result = {
        ok: false,
        message: error,
      };
    }
    return result;
  }

  async getLogoClient() {
    let result;
    try {
      let response = await this._resource('clients/logo/').get();
      result = response.body.url;
    } catch (error) {
      result = {
        ok: false,
        message: error,
      };
    }
    return result;
  }

  async getClients() {
    let result;
    try {
      let response = await this._resource('client/').get();
      result = response.json();
    } catch (error) {
      result = {
        ok: false,
        message: error,
      };
    }
    return result;
  }

  async register(client, user) {
    try {
      let data = await this._resource('clients/register').save({
        name: client.name,
        name_adm: user.name,
        email: user.email,
        email_client: client.email_client,
        phone: user.phone,
        phone_client: client.phone_client,
        cpf: user.cpf,
        type_client: client.type_client,
        client_id_parent: client.client_id_parent,
        isDeveloperClient: client.isDeveloperClient,
        mobilization_date: client.mobilization_date,
        show_in_register: client.show_in_register,
        consultant: client.consultant,
        housing_unit: client.housing_unit,
        billing_target: client.billing_target,
        initial_age_group: client.initial_age_group,
        final_age_group: client.final_age_group,
      });
      return data.json();
    } catch (e) {
      throw {
        ok: false,
        message: e.body.message,
      };
    }
  }

  async getClientsByFilters() {
    let result;
    try {
      let response = await this._resource('clients/filters').get();
      result = response.json();
    } catch (error) {
      throw {
        ok: false,
        message: error,
      };
    }
    return result;
  }

  async getAdminsByClient(clientId) {
    let result;
    try {
      let response = await this._resource(`admin/${clientId}`).get();
      result = response.json();
    } catch (error) {
      throw {
        ok: false,
        message: error,
      };
    }
    return result;
  }

  async update(client) {
    let result;
    try {
      debugger;
      let response = await this._resource(`client/${client.id}`).update(client);
      result = response.json();
    } catch (e) {
      console.log(e);
      throw {
        ok: false,
        message: e,
      };
    }
    return result;
  }

  inactivate(clientId, password) {
    const data = {
      password: password,
    };
    return this._resource(`client/inactivate/${clientId}`)
      .update(data)
      .then(res => res.json());
  }

  newRegister(object, file) {
    let data = new FormData();
    data.append('body', JSON.stringify(object));
    data.append('temosDeUso', file);
    return this._resource('clients/new-register')
      .save(data)
      .then(res => {
        return res;
      })
      .catch(e => {
        throw e.body;
      });
  }
}
